import { IonCard, IonCardContent, IonText } from '@ionic/react'
import type React from 'react'
import { format } from 'date-fns'

import { Certificate } from '../../../../lib/apollo/types'

type CertificateRenderPayload = {
    renderConfig?: {
        clubImg?: string
    }
}

export type CertificateItemProps = {
    certificate: Certificate
    setCert: (certificate: Certificate) => void
}

const parseRenderPayload = (renderPayload?: string | null): CertificateRenderPayload | undefined => {
    if (!renderPayload) return undefined

    try {
        return JSON.parse(renderPayload)
    } catch {
        return undefined
    }
}

/**
 * `Camp.start`/`Camp.end` are nullable since 4.G. `format()` throws on an
 * invalid date, so an unguarded call here would take down the whole talent page
 * — the very failure the nullable contract was meant to end.
 */
export const formatCampDate = (date?: string | null): string | undefined => {
    if (!date) return undefined

    const parsed = new Date(date)
    return isNaN(+parsed) ? undefined : format(parsed, 'MM/yyyy')
}

const getCertificateLogo = (certificate: Certificate): string => {
    const payloadLogo = parseRenderPayload(certificate.renderPayload)?.renderConfig?.clubImg?.trim()
    if (payloadLogo) return payloadLogo

    switch (certificate.club) {
        case 'hsv': return '/assets/hsv-fubaschu.jpeg'
        case 'rbl': return '/assets/rbl_fussballschule.png'
        default: return `https://client-assets.joinmytalent.pro/logos/${certificate.club}.png`
    }
}

const CertificateItem: React.FC<CertificateItemProps> = ({ certificate, setCert }) => {
    return (
        <div
            className='talent-timeline__entry-wrapper'
            key={certificate.id}
        >
            <div
                className='talent-timeline__entry'
            >
                <IonCard
                    onClick={() => setCert(certificate)}
                    key={certificate.id}
                    className='talent-timeline__certificate'
                >
                    <img
                        src={getCertificateLogo(certificate)}
                        alt={`${certificate.club} logo`}
                    />
                    <IonCardContent>
                        <div className='talent-timeline__entry__caption'>
                            {certificate.camp.caption}
                        </div>
                        {!!formatCampDate(certificate.camp?.end ?? certificate.camp?.start) && (
                            <div>
                                <IonText
                                    color='medium'
                                >
                                    {formatCampDate(certificate.camp?.end ?? certificate.camp?.start)}
                                </IonText>
                            </div>
                        )}
                    </IonCardContent>
                </IonCard>
            </div>
        </div>
    )
}

export default CertificateItem
